import { Action } from '@ngrx/store'
import { EntityLoaderMeta } from '@spartacus/core/src/state/utils/entity-loader'
import { Product, PRODUCT_DETAIL_ENTITY } from '@spartacus/core'
import {
  EntityScopedLoaderActions
} from '../../../state/utils/scoped-loader/entity-scoped-loader.action'

export const MB_LOAD_PRODUCT = '[Product] Mb Load Product Data'
export const MB_LOAD_PRODUCT_FAIL = '[Product] Mb Load Product Data Fail'
export const MB_LOAD_PRODUCT_SUCCESS = '[Product] Mb Load Product Data Success'

export interface ProductMeta extends EntityLoaderMeta {
  scope?: string;
}

export interface EntityScopedLoaderAction extends Action {
  readonly payload?: any;
  readonly meta?: ProductMeta;
}

export class MbLoadProduct extends EntityScopedLoaderActions.EntityScopedLoadAction {
  readonly type = MB_LOAD_PRODUCT
  constructor (public payload: string, scope = '') {
    super(PRODUCT_DETAIL_ENTITY, payload, scope)
  }
}

export class MbLoadProductFail extends EntityScopedLoaderActions.EntityScopedFailAction {
  readonly type = MB_LOAD_PRODUCT_FAIL
  constructor (productCode: string, public payload: any, scope = '') {
    super(PRODUCT_DETAIL_ENTITY, productCode, scope, payload)
  }
}

export class MbLoadProductSuccess extends EntityScopedLoaderActions.EntityScopedSuccessAction {
  readonly type = MB_LOAD_PRODUCT_SUCCESS

  constructor (public payload: Product, scope = '') {
    super(PRODUCT_DETAIL_ENTITY, payload.code as string, scope)
  }
}

// action types
export type MbProductAction = MbLoadProduct | MbLoadProductFail | MbLoadProductSuccess
